type TFormatValidationMessage = { errorMessage?: string; value?: number | string };

export const formatValidationMessage = ({ errorMessage, value }: TFormatValidationMessage) =>
    errorMessage?.replace('/%%value%%/g', String(value));
